import { IconNames } from "@repo/core/components/core/Icon/types";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { RootScaffoldProps } from "@repo/core/components/layout/Scaffolds/RootScaffold/types";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";

export type StoreSelectScaffoldProps = RootScaffoldProps & {
  overrideModalRef?: React.RefObject<IModalRefProps>;
  showSelectStoreBar?: boolean;
  showConfirmStoreModal?: boolean;
  selectStoreBarVariant?: StoreSelectBarVariantEnum;
  storeSelectorVariant?: StoreSelectorVariantEnum;
  topRightText?: string;
  topRightIcon?: IconNames;
  topRightOnPress?: () => void;
};

export enum StoreSelectBarVariantEnum {
  LIGHT = "light",
  GREEN = "green"
}
